document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-item]');
    if (!btn) return;
    var item = btn.closest('[data-input-item]');
    if (!item) return;
    var key = item.dataset.key;
    if (!key) return;
    e.stopImmediatePropagation();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(() => window.location.reload());
  }, true); // capture phase — fires before theme.min.js handler
});
